import Slider from 'react-slick';
import {useState} from 'react';
import renderHTML from 'react-render-html';
import './Rater.sass'
import DownArrow from '../../../icons/down_arrow.svg'
import UpArrow from '../../../icons/up_arrow.svg'
import StandardButton from "../../ui/Button/StandardButton";

const Rater = ({ slider, showChoices, handleSelection }) => {
  const [initialized, setInitialized] = useState(false)
  const setSelection = (value) => {
    handleSelection(value);
  };
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    beforeChange: (current, next) => {
      setSelection(next);
    },
  };
  const handleSlideUp = () => {
    setInitialized(true);
    slider.slickNext();
  };
  const handleSlideDown = () => {
    setInitialized(true);
    slider.slickPrev();
  };
  return (
    <div className="rater">

      <div className="up-button mb-4" onClick={() => handleSlideUp()}>
        <img
          src={UpArrow}
          width="30"
          height="30"
          alt=""
        />
      </div>
      <Slider {...settings} ref={(ref) => (slider = ref)}>
        <div className="slide-item">GOOD</div>
        <div className="slide-item">OK</div>
        <div className="slide-item">BAD</div>
      </Slider>
      <div className="down-button mt-4 mb-6" onClick={() => handleSlideDown()}>
        <img
          src={DownArrow}
          width="30"
          height="30"
          alt=""
        />
      </div>
      {!initialized?(
          <div className="rater-cover">
            <div className="rater-cover-label">
              {renderHTML("USE ARROWS<br/>TO RATE")}
            </div>
          </div>
      ):null}

      <StandardButton data={"Submit"} callback={showChoices} disabled={!initialized}/>
      {/*<button className={initialized?"submit-button":"submit-button disabled"} onClick={() => showChoices()}>
        Submit
      </button>*/}
    </div>
  );
};

export default Rater;
